import { ComponentType } from 'react';
import { DropdownButtonProps } from '../components/dropdown-button/dropdown-button';
import DropdownContext from '../contexts/dropdown.context';
import useDropdownState from '../hooks/use-dropdown-state';

const withDropdownContext = (WrapperComponent: ComponentType<Partial<DropdownButtonProps>>) => {
    return (props: DropdownButtonProps) => {
        const dropdownState = useDropdownState(props);

        return (
            <DropdownContext.Provider value={dropdownState}>
                <WrapperComponent {...props} />
            </DropdownContext.Provider>
        );
    };
};

export default withDropdownContext;
